<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <estime v-if="sas" :sasId="sas.id"></estime>
    <introduction v-show="step == 'introduction'" endpoint="demande-permis-psychologue-equivalence" @next-step="next"></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission v-show="step == 'soumission'" :showAlert="formulaireNonValide" @submit="submit" ref="soumission"></soumission>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import Identification from "@/components/PermisEquivalence/Identification"
import Diplomes from "@/components/PermisEquivalence/Diplomes"
import Cours from "@/components/PermisEquivalence/Cours"
import Recherches from "@/components/PermisEquivalence/Recherches"
import FormationsPratiques from "@/components/PermisEquivalence/FormationsPratiques"
import ExperiencesProfessionnelles from "@/components/PermisEquivalence/ExperiencesProfessionnelles"
import FormationsContinues from "@/components/PermisEquivalence/FormationsContinues"
import AutresInformations from "@/components/PermisEquivalence/AutresInformations"
import DeclarationsJudiciaires from "@/components/FormParts/DeclarationsJudiciaires"
import Soumission from "@/components/FormParts/Soumission"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import Engagements from "@/components/PermisEquivalence/Engagements"
import Estime from "@/components/FormParts/Estime"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/demande-permis-psychologue-equivalence/",
      paramsName: "permis-equivalence",
      loadPanierOnLoad: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "diplomes", code: "titre-etape-2", state: "" },
        { path: "cours", code: "titre-etape-3", state: "" },
        { path: "recherches", code: "titre-etape-4", state: "" },
        { path: "formations-pratiques", code: "titre-etape-5", state: "" },
        { path: "experiences-professionnelles", code: "titre-etape-6", state: "" },
        { path: "formations-continues", code: "titre-etape-7", state: "" },
        { path: "autres-informations", code: "titre-etape-8", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-9", state: "" },
        { path: "engagements", code: "titre-etape-10", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    Introduction,
    Identification,
    Diplomes,
    Cours,
    Recherches,
    FormationsPratiques,
    ExperiencesProfessionnelles,
    FormationsContinues,
    AutresInformations,
    DeclarationsJudiciaires,
    Soumission,
    Engagements,
    Estime
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title")
    }
  }
}
</script>

<style>
</style>
